export default __webpack_public_path__ + "static/media/places.f60bc02c.svg";